module.exports = __webpack_public_path__ + "static/img/协和万邦使命背景@2x.25b488f.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/协和万邦使命背景@2x.png
// module id = sh4u
// module chunks = 0